import type Transition from '@ember/routing/transition';
import { type Registry as Services, service } from '@ember/service';
import BaseRoute from 'uplisting-frontend/pods/base/route';
import ActionBookingsIdentityController from 'uplisting-frontend/pods/action/bookings/identity/controller';
import type { ModelRegistry } from 'ember-data/types/registries/model';

export default abstract class SidebarBookingsIdentityRoute extends BaseRoute {
  @service('repositories/guest-identity-image')
  guestIdentityImageRepository!: Services['repositories/guest-identity-image'];

  abstract parentRoute: string;

  model() {
    const booking = this.modelFor(this.parentRoute) as ModelRegistry['booking'];

    return this.guestIdentityImageRepository.getRecords(
      (
        booking.guestIdentityVerification as ModelRegistry['guest-identity-verification']
      ).id,
    );
  }

  setupController(
    controller: ActionBookingsIdentityController,
    model,
    transition: Transition,
  ): void {
    super.setupController(controller, model, transition);

    Object.assign(controller, { guestIdentityImages: model.slice() });
  }
}
